import axios from "axios";

export default {
  namespaced: true,
  state: {
    cities: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    citiesMessage: ''
  },
  mutations: {
    RECEIVED_CITIES(state, payload) {
      state.cities = payload;
      state.isReceiving = false;
    },
    RECEIVING_CITIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_CITY(state, payload) {
      state = Object.assign(state, {
        cities: [...state.cities, payload],
        isReceiving: false,
      })
    },
    RECEIVING_CITY(state) {
      state.isReceiving = true;
    },
    UPDATED_CITY(state, payload) {
      let index = state.cities.findIndex(city => city._id === payload._id);
      state = Object.assign(state, {
        cities: state.cities.map((city, i) => {
          if (i === index) {
            return Object.assign({}, city, payload);
          }
          return city;
        }),
        isUpdating: false,
        citiesMessage: 'Cities has been updating!',
      })
    },
    UPDATING_CITY(state) {
      state.isUpdating = true;
    },
    DELETED_CITY(state, payload) {
      let indexToDelete = state.cities.findIndex(city => city._id === payload._id);
      let cities = [...state.cities];
      cities.splice(indexToDelete, 1);
      state = Object.assign(state, {
        cities: [...cities],
        isDeleting: false,
        idToDelete: null,
        citiesMessage: 'City has been Deleted!',
      });
    },
    DELETING_CITY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteCityRequest({dispatch}, payload) {
      dispatch("deletingCity", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/city/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteCity", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async getCitiesRequest({dispatch}) {
      dispatch("receivingCities");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/cities';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveCities", res.data);
      })
    },
    async insertCityRequest({dispatch}, payload) {
      dispatch("receivingCity");
      let  token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/city';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveCity", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    updateCityRequest({dispatch}, payload) {
      dispatch("updatingCity");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/city/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateCity", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    receiveCities({commit}, payload) {
      commit("RECEIVED_CITIES", payload)
    },
    receivingCities({commit}) {
      commit("RECEIVING_CITIES")
    },
    receiveCity({commit}, payload) {
      commit("RECEIVED_CITY", payload)
    },
    receivingCity({commit}) {
      commit("RECEIVING_CITY")
    },
    updateCity({commit}, payload) {
      commit("UPDATED_CITY", payload)
    },
    updatingCity({commit}) {
      commit("UPDATING_CITY")
    },
    deleteCity({commit}, payload) {
      commit("DELETED_CITY", payload)
    },
    deletingCity({commit}, payload) {
      commit("DELETING_CITY", payload)
    }
  },
};
